import React, {Component} from 'react'
import Base from '../BaseComponent'
import Content from '../Content'
import Icon from '../Icon'
import ActionLogger from '../ActionLogger';
import moment from 'moment';

import {
  Link
} from 'react-router-dom';

import 'moment-timezone';

const today = moment().tz('America/New_York').format('e');
const now = parseInt(moment().tz('America/New_York').format('Hmm'));


class OpeningTimes extends Component {

	tidyUrl = (url) => {
		let newUrl = url.replace("http://","")
		newUrl = newUrl.replace("https://","")
		newUrl = newUrl.replace('/', '');
    newUrl = newUrl.replace('www.', '');
		return newUrl;
	}

  getTimes =(entry, timerPhrase) => {
    let finalTimerPhrase = timerPhrase
    if(entry.alternativeTimePhrase){
      finalTimerPhrase = entry.alternativeTimePhrase
    } else {
      if(entry.open24Hours == 1) return null
    }

    let websiteTitle = this.tidyUrl(entry.website)
    if(entry.websiteLinkText) websiteTitle = entry.websiteLinkText

    let cat = entry.locationCategory
    if(typeof entry.locationCategory == 'object') cat = entry.locationCategory[0]

    return (<div className="OpeningTimes-body">
        <ul>
          <li><Icon type={'time-yellow'} />{finalTimerPhrase}</li>
          <li>
            <Icon type={'locations-list'} />
            <ActionLogger category={entry.locationCategory} action="Menu link click" label={entry.title + ': '+entry.menuLinkTitle}>
            <Link to={entry.menuLink} target="_blank">{(entry.menuLinkTitle=='')?'Menu':entry.menuLinkTitle}</Link>
            </ActionLogger>
          </li>
          <li><Icon type={'locations-map'} />
          <ActionLogger category={entry.locationCategory} action="Directions click" label={entry.title}>
          <Link to={'https://www.google.com/maps/dir/?api=1&destination=' + entry.longitude + ',' + entry.latitude} target="_blank">Directions</Link>
          </ActionLogger></li>
        </ul>

        <ul>
          <li>
            <Icon type={'phone-yellow'} /><Link to={'tel://'+entry.phone} target="_blank">{entry.phone}</Link>
          </li>
          <li><Icon type={'instagram-yellow'} /><ActionLogger category={entry.locationCategory} action="Instagram click" label={entry.title + ': ' + entry.instagram}><Link to={'https://instagram.com/'+entry.instagram.replace('@', '')} target="_blank">{entry.instagram.replace('@', '')}</Link></ActionLogger></li>
          <li>
            <Icon type={'world-yellow'} />
            <ActionLogger category={cat} action="Website click" label={entry.title + ': '+websiteTitle}>
            <Link to={entry.website} target="_blank">{websiteTitle}</Link>
          </ActionLogger></li>
        </ul>
      </div>)
  }



  render () {

    if(this.props.location.locationCategory == 'live') return ''

  	let phrase,timerPhrase;
  	let entry = this.props.location;
  	const hours = this.props.location.openingTimes[today];
  	const opens = parseInt(moment(hours.open.date).format('Hmm'));
  	const closes = parseInt(moment(hours.close.date).format('Hmm'));

    const getTime = (t) => {
      return parseInt(moment(t).format('m')) > 0 ? moment(t).format('h.mma') : moment(t).format('ha')
    }

    if(closes < opens)
    {
      //closes after midnight (tomorrow)
      if(now > opens || now < closes){
        phrase = 'Open now';
        timerPhrase = 'Closes ' + getTime(hours.close.date)
      } else {
        phrase = 'Closed now';
        timerPhrase = 'Opens ' + getTime(hours.open.date)
      }
    } else {
      // closes before midnight
      if(now > opens && now < closes)
      {
        phrase = 'Open now'
        timerPhrase = 'Closes ' + getTime(hours.close.date)
      } else {
        phrase = 'Closed now'
        timerPhrase = 'Opens ' + getTime(hours.open.date)
      }
    }

  	console.log(now,opens,closes,hours.close.date)



  	/*if(now > opens && now < closes)
  	{
  		phrase = 'Open now'
  		timerPhrase = 'Closes ' + moment(hours.close.date).format('ha')
  	} else {
  		phrase = 'Closed now'
  		timerPhrase = 'Opens ' + moment(hours.open.date).format('ha')
  	}*/

    if(entry.open24Hours == 1) phrase = 'Always open'

    return (

    	<Base {...this.props} className="OpeningTimes">

    	<div className="OpeningTimes-head">
    		<Content> <h1>{phrase}</h1></Content>
    	</div>
    	{this.getTimes(entry,timerPhrase)}

    	</Base>


    )
  }
}

export default OpeningTimes



// WEBPACK FOOTER //
// ./src/js/components/OpeningTimes/OpeningTimes.jsx